import React, { Component } from 'react';

import { REPORT_ACTION_ITEMS } from '../../constants/constants';
import { canEditTask } from '../../utils/incidentHelper';
import ActivityCard from '../reportCards/ActivityCard';
import AttachmentCard from '../reportCards/AttachmentCard';
import CommentCard from '../reportCards/CommentCard';
import Dropdown from '../inputs/Dropdown';
import Modal from '../Modal';
import PrivateLogCard from '../reportCards/PrivateLogCard';
import TaskCard from '../reportCards/TaskCard';
import Textbox from '../inputs/Textbox';
import UserBadge from '../UserBadge';

import './index.css';

export default class ReportActions extends Component {
  state = {
    action: 0,
    openViewCommentModal: false,
    openViewLogModal: false,
    openCreateLogModal: false,
    openCreateCommentModal: false,
    activeComment: {},
    activeLogEntry: {},
    createLogEntry: '',
    createCommentEntry: ''
  };

  addAttachment = async e => {
    const files = e.target.files;

    let data = new FormData();

    Object.entries(files).forEach(async file => {
      data.append('attachments', file[1], file[1].name);
    });

    await this.props.addAttachment({
      data,
      ownerId: this.props.activeIncident._id,
      ownerType: 'incident'
    });
  };

  render() {
    const {
      action,
      openViewCommentModal,
      openViewLogModal,
      openCreateLogModal,
      openCreateCommentModal,
      activeComment,
      activeLogEntry,
      createLogEntry,
      createCommentEntry
    } = this.state;

    const {
      comments,
      notes,
      activityItems,
      attachments,
      tasks,
      loggedInUser,
      addNote,
      addComment,
      activeIncident,
      removeActionItem,
      handleReportSelection,
      setActiveTask,
      stage
    } = this.props;

    const getCompletedTasks = tasks => {
      return tasks.filter(task => task.currentWfStatus === 5);
    };

    const getOtherTasks = tasks => {
      return tasks.filter(task => task.currentWfStatus !== 5);
    };

    const getPrivateNotes = notes => {
      return notes.filter(note => note.auditLog[0].userId === loggedInUser._id);
    };

    const getRemovedAttachments = attachments => {
      return attachments.filter(attachment => attachment.isRemoved);
    };

    const getOtherAttachments = attachments => {
      return attachments.filter(attachment => !attachment.isRemoved);
    };

    const getRemovedComments = comments => {
      return comments.filter(comment => comment.isRemoved);
    };

    const getOtherComments = comments => {
      return comments.filter(comment => !comment.isRemoved);
    };

    return (
      <div className="reportActionsContainer">
        <Dropdown
          options={REPORT_ACTION_ITEMS}
          currentValue={action}
          handleChange={value =>
            this.setState({
              action: value.value
            })
          }
          inputClassName="reportActions-ddInput"
        />
        <div className="reportActions">
          {action.toString() === '0' ? (
            <div>
              {activityItems.map((activity, index) => {
                if (activity.type === 'action') {
                  return (
                    <ActivityCard
                      activity={activity.resourceData}
                      key={index}
                    />
                  );
                } else if (activity.type === 'task') {
                  return (
                    <TaskCard
                      task={activity.resourceData}
                      key={index}
                      handleReportSelection={handleReportSelection}
                      canEditTask={canEditTask(
                        activeIncident,
                        loggedInUser,
                        activity.resourceData
                      )}
                      openTaskModal={() =>
                        setActiveTask({
                          ...activity.resourceData,
                          isFromReport: activity.resourceData
                            .reportComponentName
                            ? true
                            : false,
                          isForIncident: true,
                          stage
                        })
                      }
                    />
                  );
                } else if (activity.type === 'attachment') {
                  return (
                    <AttachmentCard
                      attachment={activity.resourceData}
                      key={index}
                      removeAttachment={() =>
                        removeActionItem({
                          type: 'attachment',
                          ...activity.resourceData
                        })
                      }
                    />
                  );
                } else {
                  return <></>;
                }
              })}
            </div>
          ) : action === 1 ? (
            <div>
              {getOtherAttachments(attachments).map((attachment, index) => (
                <AttachmentCard
                  attachment={attachment}
                  key={index}
                  removeAttachment={() =>
                    removeActionItem({ type: 'attachment', ...attachment })
                  }
                />
              ))}
              {activeIncident.incidentOwner === loggedInUser._id &&
                getRemovedAttachments(attachments).length > 0 && (
                  <div>
                    <div className="reportActions-removedActionItems">
                      Removed
                    </div>
                    {getRemovedAttachments(attachments).map(
                      (attachment, index) => (
                        <AttachmentCard
                          attachment={attachment}
                          key={index}
                          removeAttachment={() =>
                            removeActionItem({
                              type: 'attachment',
                              ...attachment
                            })
                          }
                        />
                      )
                    )}
                  </div>
                )}
            </div>
          ) : action === 2 ? (
            <div>
              {getOtherComments(comments).map((comment, index) => (
                <CommentCard
                  comment={comment}
                  key={index}
                  setActiveComment={value =>
                    this.setState({
                      openViewCommentModal: true,
                      activeComment: value
                    })
                  }
                  removeComment={() =>
                    removeActionItem({
                      type: 'comment',
                      ...comment
                    })
                  }
                />
              ))}
              {getRemovedComments(comments).length > 0 && (
                <div>
                  <div className="reportActions-removedActionItems">
                    Removed
                  </div>
                  {getRemovedComments(comments).map((comment, index) => (
                    <CommentCard
                      comment={comment}
                      key={index}
                      setActiveComment={value =>
                        this.setState({
                          openViewCommentModal: true,
                          activeComment: value
                        })
                      }
                      removeComment={() =>
                        removeActionItem({
                          type: 'comment',
                          ...comment
                        })
                      }
                    />
                  ))}
                </div>
              )}
            </div>
          ) : action === 3 ? (
            <div>
              {getOtherTasks(tasks).map((task, index) => (
                <TaskCard
                  task={task}
                  key={index}
                  handleReportSelection={handleReportSelection}
                  canEditTask={canEditTask(activeIncident, loggedInUser, task)}
                  openTaskModal={() =>
                    setActiveTask({
                      ...task,
                      isFromReport: task.reportComponentName ? true : false
                    })
                  }
                />
              ))}
              {getCompletedTasks(tasks).length > 0 && (
                <div>
                  <div className="reportActions-completedTasks">Completed</div>
                  {getCompletedTasks(tasks).map((task, index) => (
                    <TaskCard
                      task={task}
                      key={index}
                      handleReportSelection={handleReportSelection}
                      canEditTask={canEditTask(
                        activeIncident,
                        loggedInUser,
                        task
                      )}
                      openTaskModal={() =>
                        setActiveTask({
                          ...task,
                          isFromReport: false,
                          isForIncident: true
                        })
                      }
                    />
                  ))}
                </div>
              )}
            </div>
          ) : (
            <div>
              {getPrivateNotes(notes).map((log, index) => (
                <PrivateLogCard
                  log={log}
                  key={index}
                  setActivePrivacyLog={value =>
                    this.setState({
                      openViewLogModal: true,
                      activeLogEntry: value
                    })
                  }
                />
              ))}
            </div>
          )}
        </div>
        <div className="reportActions-actionButtons">
          {action === 1 ? (
            <div className="reportActions-actionButton">
              <img
                src={require('../../assets/images/addAttachment.png')}
                alt="Add Attachment"
              />
              <img
                src={require('../../assets/images/addAttachmentHover.png')}
                alt="Add Attachment Hover"
                className="reportActions-actionButton--addHover"
              />
              <input
                type="file"
                name="myfile"
                onChange={e => this.addAttachment(e)}
                multiple
              />
            </div>
          ) : action === 2 ? (
            <div
              className="reportActions-actionButton"
              onClick={() => this.setState({ openCreateCommentModal: true })}
            >
              <img
                src={require('../../assets/images/createComment.png')}
                alt="Add Comment"
              />
              <img
                src={require('../../assets/images/createCommentHover.png')}
                alt="Add Attachment Hover"
                className="reportActions-actionButton--addHover"
              />
            </div>
          ) : action === 3 ? (
            <div
              className="reportActions-actionButton"
              onClick={() =>
                setActiveTask({
                  ownerId: activeIncident._id,
                  ownerType: 'incident',
                  isForIncident: true,
                  isFromReport: false,
                  groupId: activeIncident.locationId,
                  schedule: 'immediate',
                  isFromRa: false,
                  stage
                })
              }
            >
              <img
                src={require('../../assets/images/createCustomTask.png')}
                alt="Create Custom Task"
              />
              <img
                src={require('../../assets/images/createCustomTaskHover.png')}
                alt="Create Custom Task Hover"
                className="reportActions-actionButton--addHover"
              />
            </div>
          ) : action === 4 ? (
            <div
              className="reportActions-actionButton"
              onClick={() => this.setState({ openCreateLogModal: true })}
            >
              <img
                src={require('../../assets/images/addLogEntry.png')}
                alt="Add Private Log Entry"
              />
              <img
                src={require('../../assets/images/addLogEntryHover.png')}
                alt="Add Attachment Hover"
                className="reportActions-actionButton--addHover"
              />
            </div>
          ) : (
            ''
          )}
        </div>
        <Modal
          title="Comment Expanded"
          titleClassName="blueHeader"
          isOpen={openViewCommentModal}
          onRequestClose={() => this.setState({ openViewCommentModal: false })}
          hideButtons={true}
        >
          <div className="reportActions-assignee">
            <UserBadge
              userId={activeComment?.userId}
              showImage
              showName
              byline="Commented By"
            />
            <div className="reportActions-assignee--createdAt">
              <div className="reportActions-normal">
                {`Added at ${activeComment?.date?.format?.('hh:mm A')}`}
                .
              </div>
              <div className="reportActions-bold">
                {activeComment?.date?.format?.('LL')}
              </div>
            </div>
          </div>
          <div className="reportActions-viewCommentNote">
            {activeComment?.value}
          </div>
        </Modal>
        <Modal
          title="Log Entry Expanded"
          titleClassName="blueHeader"
          isOpen={openViewLogModal}
          onRequestClose={() => this.setState({ openViewLogModal: false })}
          hideButtons={true}
        >
          <div className="reportActions-assignee">
            <div className="reportActions-assignee--createdAt">
              <div className="reportLog reportActions-normal">
                {`Added at ${activeLogEntry?.date?.format?.('hh:mm A')}`}
                .
              </div>
              <div className="reportLog reportActions-bold">
                {activeLogEntry?.date?.format?.('LL')}
              </div>
            </div>
          </div>
          <div className="reportActions-viewCommentNote">
            {activeLogEntry?.value}
          </div>
        </Modal>
        <Modal
          title="Add Log Entry"
          titleClassName="blueHeader"
          isOpen={openCreateLogModal}
          submitButtonColor="blue"
          submitButtonText="Save Log Entry"
          onRequestClose={() => this.setState({ openCreateLogModal: false })}
          submitActions={() =>
            addNote({ name: createLogEntry }) &&
            this.setState({ openCreateLogModal: false, createLogEntry: '' })
          }
        >
          <div className="reportActions-createVerbage">
            <span className="reportActions-importantVerbage">
              Private log entries are not visible to other users, and are just
              for you to keep private notes on an incident.
            </span>{' '}
            If you want everyone else on the incident to see, try using the
            comments instead.
          </div>
          <Textbox
            fieldLabel="Log Entry"
            rows={5}
            type="textarea"
            placeholder="Type your log entry here."
            currentValue={createLogEntry}
            handleChange={e =>
              this.setState({ createLogEntry: e.target.value })
            }
          />
        </Modal>
        <Modal
          title="Create Comment"
          titleClassName="blueHeader"
          isOpen={openCreateCommentModal}
          submitButtonColor="blue"
          submitButtonText="Save Comment"
          onRequestClose={() =>
            this.setState({ openCreateCommentModal: false })
          }
          submitActions={() =>
            addComment({ name: createCommentEntry }) &&
            this.setState({
              openCreateCommentModal: false,
              createCommentEntry: ''
            })
          }
        >
          <div className="reportActions-createVerbage">
            <span className="reportActions-importantVerbage">
              Comments may be viewed by anyone who has access to the incident.
            </span>{' '}
            If you no other users to see it, try using the private log instead.
          </div>
          <Textbox
            fieldLabel="Comment Content"
            rows={5}
            type="textarea"
            placeholder="Type your comment here."
            currentValue={createCommentEntry}
            handleChange={e =>
              this.setState({ createCommentEntry: e.target.value })
            }
          />
        </Modal>
      </div>
    );
  }
}
